import axios from 'axios';
import apiUrl from './index';

const source = axios.CancelToken.source();
let config = {cancelToken: source.token};

const pathUrls = {
	teams: '/teams',
	search: '/search',
	banner: '/banner',
};

/**
 * Get list of teams for a member
 * @param {string} memberId - ID of the member
 * @returns {Promise} - Axios promise
 */
export async function getTeams() {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + apiUrl.path.biro + pathUrls.teams;

	return axios(
		{
			method: 'get',
			url: requestUrl,
		},
		config,
	);
}

/**
 * Search for teams
 * @param {string} query - Search query
 * @param {number} fromIndex - Start index for pagination
 * @param {number} limit - Limit of results to return
 * @returns {Promise} - Axios promise
 */
export async function searchTeams(query, fromIndex, limit) {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + apiUrl.path.biro + pathUrls.teams + pathUrls.search;

	return axios(
		{
			method: 'post',
			url: requestUrl,
			data: {
				query: query ? query : '',
				fromIndex,
				limit,
			},
		},
		config,
	);
}

export async function getTeamBanner(teamId) {
	const originalResolution = false;
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl =
		hostUrl + apiUrl.path.biro + pathUrls.teams + '/' + teamId + apiUrl.path.banner + `?variation=${originalResolution ? '400' : '200'}`;

	return axios(
		{
			method: 'get',
			url: requestUrl,
			responseType: 'arraybuffer',
		},
		config,
	);
}
